// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__yDLui","modal":"style_modal__42QOI","continueBtn":"style_continueBtn__2g7VV"};